export type HomepageReviewMarket = "international" | "domestic";
export type HomepageReviewCountry = "usd" | "inr";

export interface HomepageReview {
	id: string;
	market: HomepageReviewMarket;
	reviewer: string;
	role: string;
	rating: 4.5 | 5;
	avatarSrc: string;
	youtubeVideoId: string;
	videoTitle: string;
	viewsTarget: string;
	viewsCurrent: string;
	quote: string;
}

export const internationalReviews: HomepageReview[] = [
	{
		id: "osmani-garcia-charly-black-pau-pow",
		market: "international",
		reviewer: "Osmani Garcia Management",
		role: "International release team",
		rating: 5,
		avatarSrc: "/logos/clients/osmani-garcia.jpg",
		youtubeVideoId: "FgmwOARuEGE",
		videoTitle:
			'Osmani Garcia "La Voz" x Charly Black - Pau Pow Sing a Song (Official Video)',
		viewsTarget: "1M+",
		viewsCurrent: "2.2M",
		quote:
			"Buen empuje, tráfico limpio y reportes claros. La campaña siguió creciendo después del lanzamiento.",
	},
	{
		id: "iii-forbidden-midnight",
		market: "international",
		reviewer: "iii Official Management",
		role: "Artist campaign team",
		rating: 4.5,
		avatarSrc: "/logos/clients/iii-official.jpg",
		youtubeVideoId: "5toNHtirpVM",
		videoTitle: 'iii "Forbidden Midnight (Real ver.)" M/V',
		viewsTarget: "240K",
		viewsCurrent: "905K",
		quote:
			"公開後もリスナーが自然に増え続けました。進行も数字も見やすく、安心して任せられました。",
	},
	{
		id: "david-singh-future-beats-satisfaction",
		market: "international",
		reviewer: "Future Beats",
		role: "Label campaign team",
		rating: 5,
		avatarSrc: "/logos/clients/future-beats.jpg",
		youtubeVideoId: "J_bP6U9rMZM",
		videoTitle: "Satisfaction (Official Song) David Singh | Future Beats",
		viewsTarget: "250K",
		viewsCurrent: "306K",
		quote:
			"Simple handoff, steady traffic, target crossed. That is exactly what we needed.",
	},
];

export const domesticReviews: HomepageReview[] = [
	{
		id: "adgpi-indian-army-special-forces",
		market: "domestic",
		reviewer: "ADGPI Media Team",
		role: "Training film production team",
		rating: 5,
		avatarSrc: "https://img.youtube.com/vi/bqMW46_QUfM/mqdefault.jpg",
		youtubeVideoId: "bqMW46_QUfM",
		videoTitle:
			"ADGPI - INDIAN ARMY | Special Forces Training Film | Shot On RED",
		viewsTarget: "5M+",
		viewsCurrent: "5.7M",
		quote:
			"This one needed a careful rollout, not noisy promotion. The pacing stayed controlled, the reach was broad, and the final numbers lined up with the campaign plan.",
	},
	{
		id: "kria-film-corp-jeevan-sangharsh",
		market: "domestic",
		reviewer: "KRIA Film Corp",
		role: "Trailer marketing team",
		rating: 4.5,
		avatarSrc: "/logos/clients/kria-film-corp.jpg",
		youtubeVideoId: "07n0-TvFxic",
		videoTitle: "Jeevan Sangharsh - Official Trailer | KRIA Film Corp",
		viewsTarget: "1.2M+",
		viewsCurrent: "1.4M",
		quote:
			"They got the trailer outside our usual circle fast. Updates were clear and we did not have to keep chasing.",
	},
	{
		id: "deep-bajwa-botal-wargi",
		market: "domestic",
		reviewer: "Deep Bajwa Management",
		role: "Music release team",
		rating: 5,
		avatarSrc: "https://img.youtube.com/vi/h-6LZD__f7g/mqdefault.jpg",
		youtubeVideoId: "h-6LZD__f7g",
		videoTitle:
			"New Punjabi Song 2023 | Botal Wargi (Official Video)- Deep Bajwa | Desi Crew | Mahi Sharma",
		viewsTarget: "5M",
		viewsCurrent: "13M",
		quote:
			"We wanted the video to keep moving after the first day. The campaign built in a way that felt natural and ended up well past the original goal.",
	},
];

export const additionalHomepageReviews: HomepageReview[] = [
	{
		id: "kria-film-corp-showreel",
		market: "domestic",
		reviewer: "KRIA Film Corp Showreel Team",
		role: "Production house portfolio team",
		rating: 5,
		avatarSrc: "/logos/clients/kria-film-corp.jpg",
		youtubeVideoId: "eXltSc0uocw",
		videoTitle: "KRIA Film Corp Showreel | Production House",
		viewsTarget: "750K",
		viewsCurrent: "857K",
		quote:
			"Showreel promo was clean and quick. We got the reach without extra back-and-forth.",
	},
	{
		id: "t-series-network-ramayan",
		market: "domestic",
		reviewer: "T-Series Network",
		role: "Devotional release desk",
		rating: 4.5,
		avatarSrc: "/logos/clients/t-series-network.jpg",
		youtubeVideoId: "M44dk56dXeo",
		videoTitle: "Ramayan | Ram Katha | Bhajan | Rap Song | Bhakti Song",
		viewsTarget: "4M",
		viewsCurrent: "4.2M",
		quote:
			"The campaign helped a devotional release travel beyond the usual channel audience. Pacing stayed consistent through the first week.",
	},
	{
		id: "the-skyy-zaman",
		market: "international",
		reviewer: "The Skyy",
		role: "Music video campaign team",
		rating: 4.5,
		avatarSrc: "/logos/clients/the-skyy.jpg",
		youtubeVideoId: "VbFhaDeME8s",
		videoTitle: "Zaman Song | Shekhar Media | Cinematic Visuals",
		viewsTarget: "2M",
		viewsCurrent: "2.3M",
		quote: "Good momentum, clear reporting, no drama.",
	},
	{
		id: "aditya-music-regional-release",
		market: "domestic",
		reviewer: "Aditya Music",
		role: "Regional music marketing team",
		rating: 5,
		avatarSrc: "/logos/clients/aditya-music.jpg",
		youtubeVideoId: "M44dk56dXeo",
		videoTitle: "Regional music campaign | Aditya Music",
		viewsTarget: "1M+",
		viewsCurrent: "1.6M",
		quote:
			"They handled the campaign like a normal label workflow: clear target, steady delivery, and simple updates.",
	},
	{
		id: "jass-records-music-release",
		market: "domestic",
		reviewer: "Jass Records",
		role: "Punjabi music release team",
		rating: 4.5,
		avatarSrc: "/logos/clients/jass-records.jpg",
		youtubeVideoId: "h-6LZD__f7g",
		videoTitle: "Punjabi music campaign | Jass Records",
		viewsTarget: "5M",
		viewsCurrent: "13M",
		quote:
			"Botal Wargi kept building instead of peaking once. That made the campaign feel useful, not just flashy.",
	},
	{
		id: "zee-music-company-trailer-window",
		market: "domestic",
		reviewer: "Zee Music Company",
		role: "Trailer promotion desk",
		rating: 5,
		avatarSrc: "/logos/clients/zee-music-company.jpg",
		youtubeVideoId: "07n0-TvFxic",
		videoTitle: "Trailer window campaign | Zee Music Company",
		viewsTarget: "1M+",
		viewsCurrent: "1.4M",
		quote:
			"Fast coordination and a proper push for the trailer window. We knew where things stood every day.",
	},
	{
		id: "lahari-music-regional-push",
		market: "domestic",
		reviewer: "Lahari Music",
		role: "Regional release team",
		rating: 5,
		avatarSrc: "/logos/clients/lahari-music.jpg",
		youtubeVideoId: "VbFhaDeME8s",
		videoTitle: "Regional music campaign | Lahari Music",
		viewsTarget: "900K",
		viewsCurrent: "1.2M",
		quote:
			"Promotion stayed steady through the release week. The updates were short, clear, and useful.",
	},
];

export const homepageReviews: HomepageReview[] = [
	getReviewById("t-series-network-ramayan"),
	getReviewById("zee-music-company-trailer-window"),
	getReviewById("aditya-music-regional-release"),
	getReviewById("jass-records-music-release"),
	getReviewById("kria-film-corp-jeevan-sangharsh"),
	getReviewById("osmani-garcia-charly-black-pau-pow"),
];

export const homepageTickerReviews: HomepageReview[] = [
	getReviewById("iii-forbidden-midnight"),
	getReviewById("david-singh-future-beats-satisfaction"),
	getReviewById("adgpi-indian-army-special-forces"),
	getReviewById("deep-bajwa-botal-wargi"),
	getReviewById("the-skyy-zaman"),
	getReviewById("lahari-music-regional-push"),
];

export const featuredHomepageReviews: HomepageReview[] = [
	...homepageReviews,
	...homepageTickerReviews,
];

const homepageTickerQuotes: Record<string, string> = {
	"t-series-network-ramayan":
		"Strong reach for a devotional release, with steady pacing all week.",
	"zee-music-company-trailer-window":
		"Fast coordination, clear daily updates, strong trailer push.",
	"aditya-music-regional-release":
		"Straightforward label workflow. Target, delivery, updates.",
	"jass-records-music-release":
		"Botal Wargi kept moving after launch, not just on day one.",
	"kria-film-corp-jeevan-sangharsh":
		"Trailer reached outside our usual circle fast.",
	"osmani-garcia-charly-black-pau-pow":
		"Clean push, simple reports, no weird traffic.",
	"iii-forbidden-midnight": "公開後もリスナーが自然に増えました。",
	"david-singh-future-beats-satisfaction":
		"Quick campaign, clean updates, target cleared.",
	"adgpi-indian-army-special-forces":
		"Careful pacing for a sensitive film, with broad reach.",
	"deep-bajwa-botal-wargi": "Momentum kept building after the first day.",
	"kria-film-corp-showreel": "Quick showreel push, clean updates.",
	"the-skyy-zaman": "Good momentum, clear reporting, no drama.",
	"lahari-music-regional-push": "Steady release-week reach and clean updates.",
};

function getReviewById(id: string): HomepageReview {
	const review = [
		...internationalReviews,
		...domesticReviews,
		...additionalHomepageReviews,
	].find((candidate) => candidate.id === id);

	if (!review) {
		throw new Error(`Missing homepage review: ${id}`);
	}

	return review;
}

export function getHomepageTickerQuote(review: HomepageReview): string {
	return homepageTickerQuotes[review.id] ?? review.quote;
}

export function getHomepageReviewCountry(
	countryCode: string | null | undefined,
): HomepageReviewCountry {
	return countryCode?.trim().toUpperCase() === "IN" ? "inr" : "usd";
}

export function getHomepageReviews(
	_countryCode: string | null | undefined,
): HomepageReview[] {
	return [...homepageReviews];
}
